<template>
<div class="col-md-12 login-container" :style="{'background-image': 'url(' + require('@/assets/media/login.jpg') + ')'}">
    <div class="login-holder">
        <img id="profile-img" src="https://i.postimg.cc/nLmT08ZT/cz-M6-Ly9t-ZWRp-YS1wcml2-YXRl-Lm-Nhbn-Zh-Lm-Nvb-S9-WWVZGSS9-NQUZy-YXl-WWVZGSS8x-L3-Auc3-Zn.png" class="profile-img-card" />
        <form class="card card-container" name="form" @submit.prevent="handleRequestPassChange">
            <h6 class="reset-title">Password change requested for {{user.email}}</h6>
            <div class="form-group">
                <label for="password">Password</label>
                <input v-model="password" v-validate="'required|min:5|max:35'" name="password" type="password" class="form-control" ref="password"/>
                <div v-if="errors.has('password')" class="alert alert-danger" role="alert">{{ errors.first('password') }}</div>
            </div>
            <div class="form-group">
                <label for="confirm_password">Confirm password</label>
                <input v-validate="'required|confirmed:password'" name="confirm_password" type="password" class="form-control" data-vv-as="password"/>
                <div v-if="errors.has('confirm_password')" class="alert alert-danger" role="alert">{{ errors.first('confirm_password') }}</div>
            </div>
            <div class="form-group">
                <button class="btn btn-primary btn-block" :disabled="loading">
                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                    <span>Reset password</span>
                </button>
                <router-link class="forgot-password" to="/login">Go to login</router-link>
            </div>
            <div class="form-group">
                <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
            </div>
        </form>

    </div>
</div>
</template>

<script>
import userService from '../services/user.service';

export default {
    name: 'ResetPass',
    data() {
        return {
            confirmPassword: null,
            password: null,
            loading: false,
            message: '',
            user: {
              id: null
            }
        };
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        }
    },
    created() {
        if (this.loggedIn) {
            this.$router.push('/');
        }

        const urlHash = this.$route.query.hash

        if (urlHash) {
            userService.checkValidPassChange({
                passwordResetUrl: urlHash,
            }).then((response) => {
              this.user = response.data
            })
        }
    },
    methods: {
      handleRequestPassChange() {
            this.loading = true;
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.loading = false;
                    return;
                }

                userService.changePass({
                  id: this.user.id,
                  password: this.password
                }).then(() => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: `Password changed succesfully`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })

                    this.loading = false;
                })
                this.loading = false;
            });
      }
    }
};
</script>

<style scoped>
label {
    display: block;
    margin-top: 10px;
}

.login-container {
    position: fixed;
    left: 0;
    top: 70px;
    width: 100vw;
    height: 100vh;

    background-repeat: no-repeat;
    background-size: cover;
}

.card-container.card {
    max-width: 350px !important;
    padding: 40px 40px;
    border-radius: 8px;
}

.card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
    width: 200px;
    height: 200px;
    margin: 0 auto 10px;
    display: block;
}

.card.card-container {
    background-color: #242021;
}

.form-group label {
    color: white;
}

button.btn.btn-primary.btn-block {
    background-color: #F9B040;
    border-color: #F9B040;
}

.forgot-password {
    text-align: center;
    display: block;
    margin-top: 12px;
    color: white;
    text-decoration: underline;
}

.reset-title {
  color: white;
  text-align: center;
}
</style>
